import { component } from 'picoapp'
import Slider from '~/lib/slider'
import $ from 'quantdom'

export default component((node) => {
  const scrollTrack = $(node).find('[data-scroll-track]').el()
  const buttonPrevious = $(node).find('button.js-previous-arrow')
  const buttonNext = $(node).find('button.js-next-arrow')

  function unveilImage(image, dataSrc = 'data-lazy-src', dataSrcset = 'data-lazy-srcset') {
    if (!image) return
    const imgLazySrc = image.getAttribute(dataSrc)
    if (imgLazySrc) {
      image.src = imgLazySrc
      image.removeAttribute(dataSrc)
      image.classList.add('lazyloaded')
    }
    const imgLazySrcset = image.getAttribute(dataSrcset)
    if (!image.getAttribute('srcset') && imgLazySrcset) {
      image.srcset = imgLazySrcset
      image.removeAttribute(dataSrcset)
    }
  }
  const slider = new Slider({ el: scrollTrack }, ({ isMin, isMax, index, filtering, slides, el }) => {
    unveilImage(el)
    unveilImage(el.nextElementSibling)
    if (!filtering) {
      buttonPrevious.attr('aria-disabled', isMin)
      buttonNext.attr('aria-disabled', isMax)

      setAllThumbnailInactive()
      const activeThumbnail = $(node)
        .find(`[data-product-gallery-thumbnails] [data-active='true'][data-index='${index}']`)
        .el()
      setThumbnailActive(activeThumbnail)
      const thumbnails = $(node).find('[data-product-gallery-thumbnails]').el()

      if (window.innerWidth < 768) {
        thumbnails.scrollTo({
          left: activeThumbnail.offsetLeft - thumbnails.offsetWidth / 2 + activeThumbnail.offsetWidth / 2,
          top: 0,
          behavior: 'smooth',
        })
      } else {
        thumbnails.scrollTo({
          left: 0,
          top: activeThumbnail.offsetTop - thumbnails.offsetHeight / 2 + activeThumbnail.offsetHeight / 2,
          behavior: 'smooth',
        })
      }
    }
  })

  buttonPrevious.on('click', () => {
    slider.slideLeft()
    if (window?.gtag) {
      window.gtag('event', 'Gallery Back', {})
    }
  })

  buttonNext.on('click', () => {
    slider.slideRight()
    if (window?.gtag) {
      window.gtag('event', 'Gallery Advance', {})
    }
  })

  // Thumbnail click listener
  $(node)
    .find('[data-product-gallery-thumbnails]')
    .on('click', (e) => {
      const galleryIndex = $(e.target).attr('data-index')
      const variantId = $(e.target).attr('data-variant-id')
      slider.slideToElement(`.js-product-image[data-index='${galleryIndex}'][data-variant-id='${variantId}']`)
      if (window?.gtag) {
        window.gtag('event', 'Gallery Image click', {
          event_detail: galleryIndex,
        })
      }
    })

  function setThumbnailActive(thumb) {
    setAllThumbnailInactive()
    $(thumb).attr('aria-selected', 'true')
  }

  function setAllThumbnailInactive() {
    $(node)
      .find(`[data-product-gallery-thumbnails] [data-active="true"][aria-selected='true']`)
      .attr('aria-selected', 'false')
    $(node)
  }

  function setDesktopThumbnailHeight() {
    if (window.innerWidth > 768) {
      $('[data-product-gallery-thumbnails]').el().style.maxHeight = $('.js-main-pdp-gallery').el().clientHeight + 'px'
    } else {
      $('[data-product-gallery-thumbnails]').el().style.maxHeight = ''
    }
  }

  // Resize listener for desktop thumbnail height
  window.addEventListener('resize', (e) => {
    setDesktopThumbnailHeight()
  })
  setDesktopThumbnailHeight()
  window.addEventListener('load', (e) => {
    setDesktopThumbnailHeight()

    $('[data-product-gallery-thumbnails]').el().scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    })
  })

  // Microbus listeners
  window.MicroBus.on('variant:change', ({ detail }) => {
    const { variant_id, location } = detail
    if (location !== 'buybox') return
    slider.filter(() => {
      $(node)
        .find(`[data-variant-id]`)
        .each((el, index) => {
          el = $(el)
          if (el.attr('data-variant-id') == variant_id) {
            el.attr('data-active', 'true')
          } else if (el && el.els.length > 0) {
            el.attr('data-active', 'false')
          }
        })
      const firstActiveThumb = $(node).find(`[data-product-gallery-thumbnails] [data-active='true']`).el()
      setThumbnailActive(firstActiveThumb)
      return new Promise((resolve) => {
        resolve()
      })
    })
  })
})
